import { Injectable } from '@angular/core';

import { pessoasStorage } from "./data.service";
import { motoristasStorage } from "../../motoristas/shared/data.service";
import { MotoristaNavigationService } from "../../motoristas/shared/motorista-navigation.service";
import { MotoristaService } from "../../motoristas/shared/motorista.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { orgaosStorage } from "../../../estruturas/orgaos/shared/data.service";
import { OrgaoService } from "../../../estruturas/orgaos/shared/orgao.service";
import { OrgaoNavigationService } from "../../../estruturas/orgaos/shared/orgao-navigation.service";

@Injectable()
export class PessoaService {

    constructor(
        private _motoristaNavigationService: MotoristaNavigationService,
        private _motoristaService: MotoristaService,
        private _orgaoNavigationService: OrgaoNavigationService,
        private _orgaoService: OrgaoService,

        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(pessoasStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(pessoasStorage + "-new");
        return JSON.parse(item);
    }

    returnToOtherForm(otherForm: string, Response: any) {
        var otherFormObject: any;
        if(Response) {
            if (otherForm === motoristasStorage) {
                otherFormObject = this._motoristaService.getSessionStorage();
                otherFormObject.funcionario = Response;
                this._motoristaService.setSessionStorage(otherFormObject);
            } else if (otherForm === orgaosStorage) {
                otherFormObject = this._orgaoService.getSessionStorage();
                otherFormObject.responsavel = Response;
                this._orgaoService.setSessionStorage(otherFormObject);
            }
        }

        this._autocompleteService.clearSessionStorage(pessoasStorage);

        if (otherForm === motoristasStorage) {
            otherFormObject = this._motoristaService.getSessionStorage();
            if (otherFormObject.id) {
                this._motoristaNavigationService.goToEdit(otherFormObject.id);
            } else {
                this._motoristaNavigationService.goToNew();
            }
        } else if (otherForm === orgaosStorage) {
            otherFormObject = this._orgaoService.getSessionStorage();
            if (otherFormObject.id) {
                this._orgaoNavigationService.goToEdit(otherFormObject.id);
            } else {
                this._orgaoNavigationService.goToNew();
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/shared/pessoa.service.ts
 **/